import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import 'antd-css-utilities/utility.min.css';
import 'antd/dist/antd.css';
import { App } from 'App';
import { initMixpanel } from 'lib/mixpanel';
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import * as serviceWorker from 'serviceWorker';
import 'styles/index.css';
import { loadClarity } from 'utils/clarity/loadClarity';

Sentry.init({
	dsn: process.env.REACT_APP_SENTRY_DSN,
	integrations: [new BrowserTracing()],

	// Set tracesSampleRate to 1.0 to capture 100%
	// of transactions for performance monitoring.
	// We recommend adjusting this value in production
	tracesSampleRate: 1.0,
});

initMixpanel();
// Só definida no build de produção; sem ela, não carrega (ver INOV-1084).
loadClarity(process.env.REACT_APP_CLARITY_PROJECT_ID);

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(<App />);

serviceWorker.unregister();
